import { Button, Flex, Spin } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useAccountServiceChangeEmailEndpoint } from 'src/api/queries'
import { ApiError } from 'src/api/requests'
import { useSessionContext } from 'src/contexts'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'
import { formErrorHandler } from 'src/utils'

import { AuthHeader } from '../components'

export const ChangeEmail = () => {
  const { t } = useLocales()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const { onLogout } = useSessionContext()

  const { isPending, error, mutate } = useAccountServiceChangeEmailEndpoint({
    onError: (e: ApiError) => formErrorHandler(e.body.errors)
  })

  useEffect(() => {
    mutate({
      requestBody: {
        email: searchParams.get('email') ?? '',
        newEmail: searchParams.get('new_email') ?? '',
        token: searchParams.get('token') ?? ''
      }
    })
  }, [mutate, searchParams])

  const onRedirect = () => {
    onLogout()
    navigate(paths.auth.root)
  }

  if (isPending) return <Spin fullscreen spinning />

  return (
    <Flex vertical gap={32}>
      <AuthHeader
        title={t(
          `auth.${error ? 'email_change_error' : 'email_change_success'}`
        )}
      />

      <Button size="large" onClick={onRedirect}>
        {t('auth.return_to_auth')}
      </Button>
    </Flex>
  )
}
